export default "__VITE_ASSET__B0qkaN3t__"